import { HttpResponse, http } from 'msw';
import { BFF_ENDPOINTS } from '../../api/endpoints/BffEndpoints';
import { createMockBeneficiaries } from '../../mocks/factories';
import { toMSWPattern } from '../utils/generic';
import type { HTTP_METHODS } from './constants/generic';
import { HTTP_METHODS_VALUES } from './constants/generic';
import type { HandlerWithMapping } from './subscriptions';

export const ENDPOINTS_KEYS = {
  SUBSCRIPTION_BENEFICIARIES: 'SUBSCRIPTION_BENEFICIARIES',
};

export function createBeneficiaryHandlers(baseUrl: string): HandlerWithMapping[] {
  return [
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.SUBSCRIPTION_BENEFICIARIES)}`, ({ params }) => {
        const subscriptionId = params.subscriptionId as string;
        return HttpResponse.json(createMockBeneficiaries(subscriptionId));
      }),
      mapping: {
        pattern: 'subscription_beneficiaries',
        key: ENDPOINTS_KEYS.SUBSCRIPTION_BENEFICIARIES,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
  ];
}
